import { put } from "redux-saga/effects";

import { loadEventMetaBackgroundStart } from "services/redux/actions";

export const toEventMetaBackgroundLoader = function*() {
  yield put(loadEventMetaBackgroundStart());
};
